const appTypes = {
  WEB: 'web',
  TELEGRAM: 'telegram',
}

const isTelegramEnv = Boolean(typeof window !== 'undefined' && window.Telegram?.WebApp)

let appType = isTelegramEnv ? appTypes.TELEGRAM : appTypes.WEB

/** @type {Promise<typeof import('@telegram-apps/sdk') | null> | null} */
let telegramSdkPromise = null

function loadTelegramSdk() {
  if (!isTelegramEnv) {
    return Promise.resolve(null)
  }

  if (!telegramSdkPromise) {
    telegramSdkPromise = import('@telegram-apps/sdk').then((telegramSDK) => {
      window.telegramSDK = telegramSDK

      try {
        telegramSDK.init()

        if (telegramSDK.swipeBehavior.isSupported() && telegramSDK.swipeBehavior.mount()) {
          telegramSDK.swipeBehavior.disableVertical()
        }

        if (telegramSDK.backButton.isSupported() && telegramSDK.backButton.mount()) {
          telegramSDK.backButton.show()
        }
      } catch (e) {
        // not a fully ready Telegram WebApp
      }

      return telegramSDK
    })
  }

  return telegramSdkPromise
}

if (isTelegramEnv) {
  loadTelegramSdk()
}

export {appTypes, appType, loadTelegramSdk}
